const SubRoutes = Object.freeze({
  PASSENGERS: "/passengers",
  PAYMENT: "/payment",
  BOARDING_POINT: "/boardingPoint",
  CONFIRMED: "/confirmed",
  CANCELLED: "/cancelled"
});

export default SubRoutes;
